// extracted by mini-css-extract-plugin
export default {"quizWrapper":"QuizContainer_quizWrapper__1yoUQ"};